import type { ReactNode } from 'react';

import { VStack } from '@/components/ui/vstack';
import { useInboxQuestionGroupCardsEnabled } from '@/hooks/inbox/useInboxQuestionGroups';

type InboxRowShellProps = {
  children: ReactNode;
  /** The divider the flat list draws under a row when cards are off. */
  legacyClassName?: string;
};

/**
 * The frame around one inbox row. With nested inquiry group cards on, every row, nested or flat, sits in
 * the same rounded bordered card so the list reads as one set of cards. With them off the row
 * keeps the flat list's own divider and nothing about it changes.
 */
export function InboxRowShell({ children, legacyClassName }: InboxRowShellProps) {
  const isCardList = useInboxQuestionGroupCardsEnabled();

  if (!isCardList) {
    return <VStack className={legacyClassName}>{children}</VStack>;
  }

  return (
    <VStack className="px-3 py-1.5">
      <VStack className="overflow-hidden rounded-[14px] border border-outline-100 bg-background-0">
        {children}
      </VStack>
    </VStack>
  );
}
